import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { SuperAdminAuthService } from '../services/superadmin-auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const superAdminAuthService = inject(SuperAdminAuthService);

  // Skip auth header for login and refresh endpoints
  if (req.url.includes('/auth/login') ||
      req.url.includes('/auth/refresh') ||
      req.url.includes('/superadmin/auth/')) {
    return next(req);
  }

  // Check for super admin token first (for super admin endpoints)
  // Then fall back to regular admin token
  const superAdminToken = superAdminAuthService.getAccessToken();
  const regularToken = authService.getAccessToken();

  // Use super admin token if available, otherwise use regular token
  const token = superAdminToken || regularToken;

  // Add authorization header if token exists
  if (token) {
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(clonedReq);
  }

  return next(req);
};

